<template>
  <NavBar v-if="!isLastStep" />
  <router-view />
  <AppFooter />
</template>

<script>
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import { useHead } from '@vueuse/head'
import useFormWizard from '@/hooks/formWizard'

import NavBar from '@/components/NavBar.vue'
import AppFooter from '@/components/AppFooter.vue'

export default defineComponent({
  name: 'App',
  components: {
    NavBar,
    AppFooter
  },
  setup() {
    const { t } = useI18n()
    const { isLastStep } = useFormWizard()

    useHead({
      title: t('title'),
      htmlAttrs: {
        lang: localStorage.getItem('language')
      },
      meta: [
        {
          name: 'description',
          content: t('description')
        }
      ]
    })
    return {
      isLastStep
    }
  }
})
</script>

<style lang="scss">
@use '@/assets/style/main';
</style>
